import { memo, type PropsWithChildren, type RefObject } from 'react';

import { type GallerySection, GalleryView, type GalleryViewProps } from '@air/component-gallery-view';

import { MouseSelectionContainer } from '~/components/MouseSelectionContainer';
import { type GalleryMetadata } from '~/components/PrivateGallery/PrivateGalleryView';
import { useGallerySelectableItemsPositions } from '~/hooks/useGallerySelectableItemsPositions';
import { type UseMouseSelectionParams } from '~/hooks/useMouseSelection';

export type SelectableGalleryViewProps = {
  containerRef: RefObject<HTMLDivElement>;
  sections: GallerySection<GalleryMetadata>[];
  minSelectionTopPosition?: UseMouseSelectionParams['minSelectionTopPosition'];
} & GalleryViewProps;

export const SelectableGalleryView = memo(
  ({
    containerRef,
    sections,
    scrollElementRef,
    minSelectionTopPosition = 110,
    ...galleryViewProps
  }: PropsWithChildren<SelectableGalleryViewProps>) => {
    const { itemsPositions } = useGallerySelectableItemsPositions({
      sections,
    });

    return (
      <MouseSelectionContainer
        scrollElementRef={scrollElementRef}
        containerRef={containerRef}
        itemsPositions={itemsPositions}
        minSelectionTopPosition={minSelectionTopPosition}
      >
        <GalleryView scrollElementRef={scrollElementRef} sections={sections} {...galleryViewProps} />
      </MouseSelectionContainer>
    );
  },
);

SelectableGalleryView.displayName = 'SelectableGalleryView';
